/**
 * Created by jv on 26/01/2017.
 */
const utils = require("Sources/utils/utils");

module.exports = class Article
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.key = options.key;
    this.catalogKey = options["catalog-key"];

    this.priceVat = options["price-with-vat"];
    this.priceNoVat = options["price-without-vat"];
    this.vat = options.vat;

    this.alreadyOwned = options["already-owned"];

    this.infoKey = options["info-key"];

    this.type = options.article.type;
    this.title = options.article.title;
    this.author = options.article.author;
    this.description = options.article.description;
    this.publisher = options.article.publisher;
    this.image = options.article.image;
    this.download = options.article.download;
    this.age = options.article.age;

    /*
    if(utils.isNotNull(options.article.meta))
    {
      this.themes = utils.isString(options.article.meta.themes) ? options.article.meta.themes.split(",") : options.article.meta.themes;
      this.games = utils.isString(options.article.meta.games) ? options.article.meta.games.split(",") : options.article.meta.games;
    }
    */

    this.purchasable = options.article.purchasable;
    this.purchaseOnce = options.article["purchase-once"];
    this.physicalDelivery = options.article["physical-delivery"];
    this.digitalDelivery = options.article["digital-delivery"];

    this.remark = options.article.remark;
  }

  get vatPercentage()
  {
    return this.vat * 100;
  }

  get readableType()
  {
    switch(this.type)
    {
      case "book":
        return "store.catalog.article_details.physical_book";
      case "digital_product":
        return "store.catalog.article_details.digital_product";
      default:
        return null;
    }
  }
};



// WEBPACK FOOTER //
// ./app/js/models/store/article.js